import {pulseUserAtom} from 'atoms/auth';
import {Layout} from 'components/DSYS/Layout';
import {Title} from 'components/DSYS/Title';
import {ROUTE_PATHS} from 'constant';
import {useDocumentTitle} from 'hooks/useDocumentTitle';
import {t} from 'i18next';
import {useAtomValue} from 'jotai';
import {NotFound} from 'pages/NotFound';

import {isAdminEnabled} from './Admin';
import {KnowledgeLinksEditor} from './KnowledgeLinksEditor';

const KnowledgeLinksPage = () => {
  const title = t('admin_knowledge_links');
  useDocumentTitle(title);

  return (
    <Layout.Container
      breadcrumb={[
        {children: 'Admin', to: ROUTE_PATHS.ADMIN},
        {children: title, to: ROUTE_PATHS.ADMIN_KNOWLEDGE_LINKS},
      ]}
    >
      <Title size={24}>{title}</Title>
      <KnowledgeLinksEditor />
    </Layout.Container>
  );
};

export const AdminKnowledgeLinks = () => {
  const pulseUser = useAtomValue(pulseUserAtom);

  if (!pulseUser) {
    return null;
  }

  if (!isAdminEnabled(pulseUser)) {
    return <NotFound />;
  }

  return <KnowledgeLinksPage />;
};
